const React = require('react');
const createReactClass = require('create-react-class');
const assign = require('object-assign');
const FuzzyReaction = require('../../bootstrap').FuzzyReaction;
const Modal = FuzzyReaction.Components.Global.Modal;
const Column = FuzzyReaction.Components.PageStructure.Column;
const Row = FuzzyReaction.Components.PageStructure.Row;
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const Button = FuzzyReaction.Components.Global.Button;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const FormStore = FuzzyReaction.Stores.FormStore;
const StringsStore = require('../../stores/StringsStore');
const legalDisclaimerImg = require('../../images/legal-disclaimer.png');

/**
 * The Users list page view component
 *
 * @type {*|Function}
 */
const LegalDisclaimer = createReactClass({
    displayName: 'LegalDisclaimer',

    getInitialState: function () {
        return {
            openPreviewModal: false,
            legalDisclaimer: {}
        }
    },

    resourceActions: new ResourceActions('documents'),

    /**
     * Legal disclaimer form key
     */
    formKey: 'editLegalDisclaimer',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            filters: {
                slug: '=LEGAL_DISCLAIMER'
            }
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {
            other: {
                show_deleted: true
            }
        },
        dataNode: 'data'
    },

    /**
     * Fire an action to request data from the API
     */
    requestData: function (modifiers) {
        // Merge modifiers with already present ones
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        this.resourceActions.listResource(this.getOptions);
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        this.requestData();

        this.changeListener = this._onChange;
        StringsStore.addChangeListener(this.changeListener);
        FormStore.addChangeListener(this.bindResource);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        StringsStore.removeChangeListener(this.changeListener);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Handle changes in data and request paginated data
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            legalDisclaimer: StringsStore.getLegalDisclaimer()
        });
    },

    /**
     * Bind Resource changes
     */
    bindResource: function () {
        this.setState({
            legalDisclaimer: FormStore.getResource(this.formKey),
            formIsValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Handle button actions
     *
     * @param action
     * @param event
     */
    handleAction: function (action, event) {
        switch (action) {
            case 'preview':
                this.setState({
                    openPreviewModal: true
                });
                break;
            case 'save':
                this.resourceActions.updateResource(this.state.legalDisclaimer, this.sendOptions);
                break;
        }
    },

    /**
     * Handle modal close state
     */
    closeModal: function () {
        this.setState({
            openPreviewModal: false
        });
    },

    /**
     * Save legal disclaimer from the preview modal
     *
     * @param event
     */
    saveFromPreview: function (event) {
        this.handleAction('save');
    },

    /**
     * Render some help text for the legal disclaimer
     *
     * @returns {string}
     * @private
     */
    _renderHelpText: function () {
        if (typeof this.state.legalDisclaimer.updated_at === 'undefined') {
            return;
        }

        var date = new Date(this.state.legalDisclaimer.updated_at);
        return 'Last edited: ' + date.toDateString();
    },

    /**
     * Parse the legal disclaimer to display it in the preview modal
     */
    parseText: function () {
        if (this.state.legalDisclaimer.value) {
            var text = this.state.legalDisclaimer.value.split('\n');

            return text.map(function (block, index) {
                return (
                    <p key={index}>{block}</p>
                );
            })
        }
    },

    render: function () {
        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"></div>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">Legal Disclaimer</h1>
                        </Column>

                        <Column grid="lg" size="6">
                            <div className="page-header float-right">
                                <Button action="preview" handleAction={this.handleAction} mods={['warning']}
                                        text="Preview"/>
                                <Button action="save" handleAction={this.handleAction} mods={['primary']} text="Save"/>
                            </div>
                        </Column>
                    </Row>

                    <Row>
                        <Column grid="lg" size="8" classes="offset-lg-2">
                            <div className="card card-default">
                                <Form key={"editLegalDisclaimer" + this.state.legalDisclaimer.id} formKey={this.formKey}
                                      bindResource={this.state.legalDisclaimer}>
                                    <Column grid="lg" size="10" classes="offset-lg-1">
                                        <Form.TextArea fieldKey="value" rows={30} limit={10000}
                                                       validations="isLength:1:10000"
                                                       helpText={this._renderHelpText()}/>
                                    </Column>
                                </Form>

                                <div className="clearfix"></div>
                            </div>
                        </Column>
                    </Row>
                </div>

                <Modal openWhen={this.state.openPreviewModal} options={{width: '29%'}}
                       title="Preview Changes"
                       closeText="Continue Editing" saveText="Save"
                       afterClose={this.closeModal}
                       beforeSave={this.saveFromPreview}
                       afterSave={this.closeModal}>
                    <Column grid="md" size="10" classes="offset-xs-1 legal-preview-image">
                        <Row>
                            <div className="legal-overlay-container">
                                <img src={legalDisclaimerImg} alt={'legal disclaimer background image'}/>
                                <div>{this.parseText()}</div>
                            </div>

                            <div className="spacer"></div>
                        </Row>
                    </Column>
                </Modal>

            </div>
        )
    },
});

module.exports = LegalDisclaimer;
